import apiClient from './apiClient';

const API_URL = '/tramites/rti';

// Obtener todos los trámites RTI o filtrar por idCliente y/o estado
export const getTramitesRTI = async (idCliente = null, idEstadoActual = null) => {
    const params = {};
    if (idCliente && idCliente.trim() !== '') params.idCliente = idCliente;
    if (idEstadoActual) params.idEstadoActual = idEstadoActual;

    const response = await apiClient.get(API_URL, { params });
    return response.data;
};

// Crear un nuevo trámite RTI
export const crearTramiteRTI = async (tramiteData) => {
    try {
        const response = await apiClient.post(API_URL, tramiteData);
        return response.data;
    } catch (error) {
        console.error('Error al crear trámite RTI:', error.response?.data || error.message);
        throw error;
    }
};

// Obtener trámites RTI para reportes (sin paginación, con filtros de fecha)
export const getReporteTramitesRTI = async (fechaDesde = null, fechaHasta = null) => {
    const params = { size: 10000 }; // Traer muchos registros sin paginar

    if (fechaDesde && String(fechaDesde).trim() !== '') {
        params.fechaDesde = String(fechaDesde).trim();
    }
    if (fechaHasta && String(fechaHasta).trim() !== '') {
        params.fechaHasta = String(fechaHasta).trim();
    }

    const response = await apiClient.get(`${API_URL}/reportes`, { params });
    return response.data;
};
